import {ToastContainerProps} from "react-toastify";
import styled, {StyledComponent} from "styled-components";
import {Color} from "../../../../../common/utils/color-util";
import {ToastClassNames} from "../../../../services/toaster/toast-helpers/toast-classnames.helper";
import {OrbitTheme} from "../../../../themes/architecture/orbit-theme.interface";
import {ToastContainerDefaultBox} from "./toast-container.default.box";

/**
 * https://fkhadra.github.io/react-toastify/how-to-style#how-to-style-with-styled-components
 * Following this link there are two ways to style toast with styles components.
 * I chose the second one: "Pass css classes to props" https://fkhadra.github.io/react-toastify/how-to-style#how-to-style-with-styled-components
 * Because I am wrapping ToastContainer in a styled component, we won't be able to use the theme prop to set "dark", "light" or "colored".
 * Theme will be set by the styled-components library to OrbitTheme.
 * However, when dispatching a toast we can specify the theme in the options parameter: toast.custom(<SomeCustomContent />, {theme: "dark"});
 * default is "light"
 */
export const ToastContainerMrGreenBox = styled(ToastContainerDefaultBox)`

    .Toastify__progress-bar--bg {
        background-color: ${({theme}) => theme.colors.background};
    }

    /* toastClassName */
    .${ToastClassNames.Toast} {

        &.orbit-toast-jackpot {
            /* padding: 0; */
            border: none;
            background-color: ${({theme}) => Color.fromHex(theme.colors.backgroundLight, 0.9).hexa()};
            @media ${({theme}) => theme.mediaQuery.sAndBelow} {
                background-color: ${({theme}) => Color.fromHex(theme.colors.backgroundLight, 0.7).hexa()};
            }
            /* TODO: After the MrG rebranding the colors #03241C and #DDDCAA should come from theme */
            box-shadow: 0px 0px 20px 0px ${({theme}) => theme.colors.boxBorderDark},
                inset 0px 0px 24px 0px #03241C,
                inset 0px 0px 4px 1px #DDDCAA;

            /* TODO: After the MrG rebranding the color #DDDCAA should come from theme */
            .Toastify__close-button.Toastify__close-button--light, .Toastify__close-button.Toastify__close-button--dark, button[aria-label="close"] {
                color: #DDDCAA;
            }
            /* TODO: After the MrG rebranding the color #DDDCAA should come from theme */
            .Toastify__progress-bar {
                background-color: #DDDCAA;
            }
            .Toastify__progress-bar--bg {
                background-color: ${({theme}) => theme.colors.backgroundDark};
            }
        }
    }

` as StyledComponent<React.ForwardRefExoticComponent<ToastContainerProps & React.RefAttributes<HTMLDivElement>>, OrbitTheme, {}, never>;
